export const overDueData = [
    {
        id: 1,
        description: 'Payment of GST',
        dueBy: '2024-04-04T00:00:00Z'
    },
    {
        id: 2,
        description: 'GST',
        dueBy: '2024-04-06T00:00:00Z'
    },
    {
        id: 3,
        description: 'Audit',
        dueBy: '2024-04-08T00:00:00Z'
    },
    {
        id: 4,
        description: 'Payment of GST',
        dueBy: '2024-04-12T00:00:00Z'
    },
    {
        id: 5,
        description: 'Payment of GST',
        dueBy: '2024-04-04T00:00:00Z'
    },
    {
        id: 6,
        description: 'GST',
        dueBy: '2024-04-06T00:00:00Z'
    },
    {
        id: 7,
        description: 'Audit',
        dueBy: '2024-04-08T00:00:00Z'
    },
    {
        id: 8,
        description: 'Payment of GST',
        dueBy: '2024-04-12T00:00:00Z'
    },
    {
        id: 9,
        description: 'Payment of GST',
        dueBy: '2024-04-04T00:00:00Z'
    },
    {
        id: 10,
        description: 'GST',
        dueBy: '2024-04-06T00:00:00Z'
    },
    {
        id: 11,
        description: 'Audit',
        dueBy: '2024-04-08T00:00:00Z'
    },
    {
        id: 12,
        description: 'Payment of GST',
        dueBy: '2024-04-12T00:00:00Z'
    }
]
export const NUMERIC = 'numeric'
export const SHORT = 'short'
export const RESP_RACID = 1
export const ACC_RACID = 2
export const cutOffTrue = true
export const cutOffFalse = false
export const radioDuebyValue = 1
export const radioCutOffValue = 2
export const BINARY_CONTROL_ID = 1
export const FORM_CONTROL_ID = 2
export const THRESHOLD_CONTROL_ID = 3
export const CHECKLIST_CONTROL_ID = 4

export const DEPARTMENT_KEY = 'department'
export const ROLE_KEY = 'role'
export const USER_KEY = 'user'

export const OPTION_FREQUENCY = 'Frequency'
export const OPTION_CATEGORY = 'Category'
export const OPTION_DEPARTMENT = 'Department'
export const OPTION_RESPONSIBLE = 'Responsible'
export const OPTION_ACCOUNTABLE = 'Accountable'
export const OPTION_CONSULTED = 'Consulted'
export const OPTION_INFORMED = 'Informed'
export const OPTION_TOTAL = 'Total'
export const EVENT_DUE_FOR = 'eventDueFor'
export const EVENT_DATE = 'eventDate'
export const compChipColorStyle = (name) => {
    const data = {}
    switch (name) {
    case 'dueDate':
        data.name = 'Hard Target'
        data.lineColor = 'hsl(var(--High))'
        break
    case 'hardTarget':
        data.name = 'Hard Target'
        data.lineColor = 'hsl(var(--High))'
        break
    case 'cutoff':
        data.name = 'Soft Target'
        data.lineColor = 'hsl(var(--soft-target))'
        break
    case 'softTarget':
        data.name = 'Soft Target'
        data.lineColor = 'hsl(var(--soft-target))'
        break
    case 'closed':
        data.name = 'Closed'
        data.lineColor = 'hsl(var(--Low))'
        break
    case 'overdue':
        data.name = 'Overdue'
        data.lineColor = 'hsl(var(--danger))'
        break
    case 'beforeDue':
        data.name = 'Scheduled'
        data.lineColor = 'hsl(var(--card))'
        break
    case 'scheduled':
        data.name = 'Scheduled'
        data.lineColor = 'hsl(var(--scheduled))'
        break
    case 'approved':
        data.name = 'Approved'
        data.lineColor = 'hsl(var(--initiated))'
        break
    default:
        break
    }
    return data
}

export const raciColor = (name) => {
    const raciLet = {}
    switch (name) {
    case 'responsible':
        raciLet.color = 'hsl(var(--light-blue))'
        raciLet.raciLetter = 'R'
        break
    case 'accountable':
        raciLet.color = 'hsl(var(--light-red))'
        raciLet.raciLetter = 'A'
        break
    case 'consulted':
        raciLet.color = 'hsl(var(--light-greenish))'
        raciLet.raciLetter = 'C'
        break
    case 'informed':
        raciLet.color = 'hsl(var(--light-primary))'
        raciLet.raciLetter = 'I'
        break
    default:
        break
    }
    return raciLet
}
export const week = [
    {
        label: 'Monday',
        value: 2
    },
    {
        label: 'Tuesday',
        value: 3
    },
    {
        label: 'Wednesday',
        value: 4
    },
    {
        label: 'Thursday',
        value: 5
    },
    {
        label: 'Friday',
        value: 6
    },
    {
        label: 'Saturday',
        value: 7
    },
    {
        label: 'Sunday',
        value: 1
    }
]
export const WEEKLY = 5
export const EVENT_BASED = 6
